import React, {useState} from "react";
import Tr from "translations/Translations";
import PropTypes from "prop-types";
import Dialog from "components/Dialog";
import VATItems, {SELECT_VALUE} from "constants/VATItems";
import {FormControl, InputAdornment, RadioGroup as RadioGroupUI, TextField} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import RadioGroupElement from "components/RadioGroupElement";
import {calcGrossValue, calcNetValue} from "libs/netGrosCalculations";
import toFloat from "libs/toFloat";
import MultiButton, {createButton} from "components/popup/components/MultiButton";

const useStyle = makeStyles(theme => ({
    root: {},
    grid: {
        '&>*': {
            flexGrow: 1,
            '&:not(:first-child)': {
                marginLeft: theme.spacing(2)
            }
        }
    },
    iconButton: {
        padding: theme.spacing(1) / 2,
    },
    otherTextInput: {
        width: 100,
        marginLeft: theme.spacing(2)
    }
}));


const NetGrossCalcPopup = (
    {
        open,
        onClose,
        disabled,
        tooltip,
        netValue,
        setNetValue,
        grossValue,
        setGrossValue

    }) => {
    const classes = useStyle();
    const [optionValue, setOptionValue] = useState(null);
    const [otherValue, setOtherValue] = useState("");

    const notSelected = optionValue === null || (optionValue === SELECT_VALUE.OTHER && !otherValue)

    const doCalcNetValue = () => {
        let otherVatValue;
        if (optionValue === SELECT_VALUE.OTHER)
            otherVatValue = Number.parseFloat(otherValue);
        let newNetValue = calcNetValue(toFloat(grossValue), optionValue, otherVatValue);
        setNetValue(newNetValue);
        onClose();
    }
    const doCalcGrossValue = () => {
        let otherVatValue;
        if (optionValue === SELECT_VALUE.OTHER)
            otherVatValue = Number.parseFloat(otherValue);

        let newGrossValue = calcGrossValue(toFloat(netValue), optionValue, otherVatValue);
        setGrossValue(newGrossValue);
        onClose();
    }


    const handleOtherChange = (e) => {
        let reg = /(?!(\d|[.,]))\D/
        const value = e.target.value;
        let _value = value;
        if (_value.length > 0) {
            _value = _value.replace(reg, "")
            _value = _value.replace(/,/g, '.')
            _value = _value.replace(/\.\./g, '.')
        }
        let valueSplit = _value.split('.')
        if (valueSplit.length > 2) {
            valueSplit = valueSplit.slice(0, 2)
        }
        if (valueSplit.length > 1) {
            valueSplit[1] = valueSplit[1].slice(0, 2);
        }
        valueSplit[0] = valueSplit[0].slice(0, 2)
        _value = valueSplit.join('.');
        setOtherValue(_value);
    }

    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr('calc_net'), doCalcNetValue, undefined, notSelected || !grossValue));
        buttons.push(createButton(Tr('close'), onClose, 'outlined', false));
        buttons.push(createButton(Tr('calc_gross'), doCalcGrossValue, undefined, notSelected || !netValue));
        return buttons;
    }

    return (<Dialog
        onClose={onClose}
        open={open}
        title={Tr('vat_calc')}
        maxWidth='xs'
        dialogActions={
            <MultiButton
                buttons={getButtons()}
            />
        }
    >

        <FormControl>
            <RadioGroupUI
                onChange={(e) => {
                    setOptionValue(e.target.value);
                }}
                value={optionValue}
            >
                {VATItems.map((item, i) => {
                    const value = String(item.value);
                    const label = item.label;

                    return (
                        <RadioGroupElement
                            key={value}
                            value={value}
                            disabled={value === SELECT_VALUE.DIFFRENT_VAT}
                        >
                            {label}
                            {value === SELECT_VALUE.OTHER &&
                                <TextField
                                    onClick={() => setOptionValue(SELECT_VALUE.OTHER)}
                                    className={classes.otherTextInput}
                                    InputProps={{
                                        endAdornment:
                                            <InputAdornment position='end'>%</InputAdornment>
                                    }}
                                    value={otherValue}
                                    onChange={handleOtherChange}
                                />

                            }

                        </RadioGroupElement>
                    )
                })}
            </RadioGroupUI>
        </FormControl>


    </Dialog>)
}

NetGrossCalcPopup.propTypes = {
    onClose: PropTypes.func.isRequired,
}

export default NetGrossCalcPopup;